import { api } from './axios';

export interface DadosGeolocalizacao {
  latitude: number;
  longitude: number;
  precisao?: number;
  metodo: 'gps' | 'ip';
  ip?: string;
  cidade?: string;
  pais?: string;
}

export interface IPInfo {
  ip: string;
}

export interface GeolocalizacaoIPResponse {
  latitude: number;
  longitude: number;
  cidade?: string;
  pais?: string;
}

class GeolocalizacaoService {
  /**
   * Obtém o IP do usuário através do backend
   */
  private async obterIP(): Promise<string> {
    try {
      const response = await api.get<IPInfo>('/meu-ip');
      return response.data.ip;
    } catch (error) {
      console.error('Erro ao obter IP do backend:', error);
      
      // Fallback: tenta obter IP público através de serviço externo
      try {
        const publicIPResponse = await fetch('https://api.ipify.org?format=json');
        const publicIPData = await publicIPResponse.json();
        return publicIPData.ip;
      } catch (publicIPError) {
        console.error('Erro ao obter IP público:', publicIPError);
        return 'unknown';
      }
    }
  }

  /**
   * Obtém geolocalização baseada no IP através do backend
   */
  /*
  private async geolocalizarPorIP(): Promise<GeolocalizacaoIPResponse | null> {
    try {
      const response = await api.get<GeolocalizacaoIPResponse>('/geolocalizacao-ip');
      return response.data;
    } catch (error) {
      console.error('Erro ao geolocalizar por IP:', error);
      return null;
    }
  }
  */

  /**
   * Tenta obter localização usando Geolocation API do navegador
   */
  /*
  private async obterLocalizacaoGPS(): Promise<DadosGeolocalizacao | null> {
    if (!navigator.geolocation) {
      return null;
    }

    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          timeout: 5000,
          enableHighAccuracy: true,
          maximumAge: 0
        });
      });

      const ip = await this.obterIP();

      return {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        precisao: position.coords.accuracy,
        metodo: 'gps',
        ip
      };
    } catch {
      return null;
    }
  }
  */

  /**
   * Captura a localização do usuário
   * Tenta usar GPS primeiro, depois IP como fallback
   */
  async capturarLocalizacao(): Promise<DadosGeolocalizacao> {
    // Tenta obter localização por GPS primeiro
    /*
    const localizacaoGPS = await this.obterLocalizacaoGPS();
    
    if (localizacaoGPS) {
      return localizacaoGPS;
    }
    */

    // Fallback: usa geolocalização por IP
    const ip = await this.obterIP();
    /*
    const geoIP = await this.geolocalizarPorIP();

    if (geoIP) {
      return {
        latitude: geoIP.latitude,
        longitude: geoIP.longitude,
        metodo: 'ip',
        ip,
        ...(geoIP.cidade && { cidade: geoIP.cidade }),
        ...(geoIP.pais && { pais: geoIP.pais })
      };
    }
    */

    // Fallback final: coordenadas zeradas
    console.warn('Não foi possível obter localização, usando coordenadas padrão');
    return {
      latitude: 0,
      longitude: 0,
      metodo: 'ip',
      ip
    };
  }

  /**
   * Formata as coordenadas para o formato esperado pelo backend (latitude,longitude)
   */
  formatarCoordenadas(dados: DadosGeolocalizacao): string {
    return `${dados.latitude},${dados.longitude}`;
  }
}

export const geolocalizacaoService = new GeolocalizacaoService();
